import { defineStore } from 'pinia'
import type { IMultiselectOption } from '~/types'

export const useCreditsFiltersStore = defineStore('credits-filters', {
  state: () => ({
    searchQuery: '',
    creditAmount: undefined as number | undefined,
    currency: '',
    selectedPeriod: [] as IMultiselectOption[],
    selectedPurpose: [] as IMultiselectOption[],
    selectedOrganizationType: '0',
    selectedIncomeConfirmation: undefined as string | undefined,
    selectedGuaranteeRequiredType: undefined as string | undefined,
    selectedType: [] as IMultiselectOption[],
    page: 1
  }),
  actions: {
    reset() {
      this.searchQuery = ''
      this.creditAmount = undefined
      this.currency = ''
      this.selectedPeriod = []
      this.selectedPurpose = []
      this.selectedOrganizationType = '0'
      this.selectedIncomeConfirmation = undefined
      this.selectedGuaranteeRequiredType = undefined
      this.selectedType = []
      this.page = 1
    }
  }
})
